import {logging} from '@telstra-connect/logger'
import {NewRelicWebLogger} from './new-relic-web-logger'

export const enableLogging = () => {
  logging.enableProdLogger(NewRelicWebLogger)
}
